var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-layout-template',{attrs:{"isBread":true,"breadHeading":'プライバシーポリシー'},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('static-contents')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }